// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"205":"6d1e8c06","551":"7b7600cc","672":"332bc678","842":"d851bbf6"}[chunkId] + ".chunk.js");